const CORPORATE_BOOKING_CHANNELS = new Set([
  "corporate_portal",
  "corporate",
  "company_portal",
]);

function normalized(value) {
  return String(value ?? "").trim().toLowerCase();
}

function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function recordFrom(value) {
  if (isObject(value)) return value;
  if (typeof value !== "string") return {};
  try {
    const parsed = JSON.parse(value);
    return isObject(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function truthy(value) {
  return value === true || value === 1 || ["1", "true", "yes", "y"].includes(normalized(value));
}

/**
 * Resolves only persisted, business-owned source markers. This intentionally
 * does not infer source from an agent, customer, or product name.
 */
export function resolveOrderSourceBadge(order) {
  if (!isObject(order)) return null;

  const clientsInfo = recordFrom(order.clientsinfo);
  const campaignHotel = recordFrom(order.admin_campaign_hotel);
  const bookingSource = normalized(
    order.booking_source ?? order.bookingSource ?? campaignHotel.booking_source
  );
  const product = normalized(order.product ?? order.product_type ?? order.deal_type);
  const hasCampaignMarker = Boolean(
    clientsInfo.campaign ||
      order.campaign ||
      order.campaign_slug ||
      campaignHotel.campaign ||
      campaignHotel.campaign_slug ||
      order.admin_campaign_hotel ||
      bookingSource === "campaign" ||
      product === "campaign"
  );

  if (hasCampaignMarker) {
    return { key: "campaign", label: "הזמנת קמפיין" };
  }

  const bookingChannel = normalized(order.booking_channel ?? order.bookingChannel);
  const orderSource = normalized(order.order_source ?? order.orderSource ?? order.source);
  const hasCorporateMarker =
    truthy(order.is_corporate_order) ||
    truthy(order.isCorporateOrder) ||
    CORPORATE_BOOKING_CHANNELS.has(bookingChannel) ||
    CORPORATE_BOOKING_CHANNELS.has(bookingSource) ||
    orderSource === "corporate_checkout" ||
    CORPORATE_BOOKING_CHANNELS.has(orderSource) ||
    order.corporate_order_id != null ||
    order.corporateOrderId != null;

  return hasCorporateMarker ? { key: "corporate", label: "אתר HotelsRiver Business" } : null;
}
